import React from "react";
import { useAppSelector } from "../../redux/hooks.ts";
import { Loading } from "../common/Loading.tsx";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

export const IsValidatedMiddleware: React.FC<Props> = ({ children }) => {
  const { userInfo, token } = useAppSelector((state) => state.auth);
  const isAuthorized = !!token && !!userInfo?.is_validated;

  if (userInfo?.is_validated === undefined) return <Loading />;

  return (
    <>{isAuthorized ? children : <Navigate to="/auth/change-password" />}</>
  );
};
